import { Directive, ElementRef, inject, Input } from '@angular/core';

@Directive({
  selector: 'img[appImgFallback]',
  standalone: true,
  host: {
    '(error)': 'updateSrc()',
    '[src]': 'src'
  }
})
export class ImgFallbackDirective {

  @Input({ required: true }) type: 'poster' | 'product';
  @Input({ required: true }) set src(val: string) {
    this._src = val ? val : this.fallbackImg ?? this._fallbackImages[this.type];
  };
  @Input() fallbackImg: string;
  @Input() hiddenClass = 'visibility-hidden';

  private _src: string;
  private readonly _fallbackImages = {
    'poster': '/assets/images/placeholders/poster-placeholder-light.svg',
    'product': null
  };
  private readonly _elementRef = inject<ElementRef<HTMLImageElement>>(ElementRef);

  public get src(): string {
    return this._src;
  }

  public updateSrc(): void {
    this._src = this.fallbackImg ?? this._fallbackImages[this.type];

    if (!this._src) {
      this._elementRef.nativeElement.classList.add(this.hiddenClass);
    }
  }
}
